import { Team } from './team.model';
import { User } from './user.model';

export interface TeamUser {
    user: User;
    team: Team;
    position?: string;
    role?: string;
    experience?: string;
}

export const teamMemberPosition = {
    president: 'president',
    vicePresident: 'vice_president',
    rapporteur: 'rapporteur',
    member: 'member',
    rapporteurMember: 'rapporteur_member',
} as const;
